import { Link } from 'react-router';

import useNavigationLinkInteraction from '~/hooks/useNavigationLinkInteraction';
import useRegion from '~/hooks/useRegion';

import { getMenu } from '.';

type NavItemProps = {
  external?: boolean;
  link: string;
  name: string;
  onClick?: () => void;
};

const navItemClassName =
  'block rounded-[30px] bg-[#3d3d4c] px-2.5 py-[5px] text-[14px] font-semibold leading-6 text-white no-underline min-[1200px]:bg-transparent min-[1200px]:px-0';

const MarketplaceFooter = () => {
  const { code } = useRegion();
  const fireFooterLink = useNavigationLinkInteraction('footer');
  const today = new Date();

  const CopyRightText = () => (
    <>
      <span>{`© ${today.getFullYear()} Sole Supplier® .`}</span>
      <span>{`All rights Reserved®  Company Reg No. 09098756`}</span>
    </>
  );

  const NavItem = ({ link, name, external, onClick }: NavItemProps) =>
    external ? (
      <a
        data-testid="footer-nav-link"
        href={link}
        key={name}
        className={navItemClassName}
        onClick={onClick}
      >
        {name}
      </a>
    ) : (
      <Link
        data-testid="footer-nav-link"
        to={link}
        key={name}
        className={navItemClassName}
        onClick={onClick}
      >
        {name}
      </Link>
    );

  return (
    <div className="bg-black text-white" data-testid="marketplace-footer">
      <div className="content-width relative mx-auto box-border flex flex-col justify-between py-10 lg:static min-[1200px]:flex-row">
        <div
          className="mb-[30px] flex flex-wrap items-center justify-center gap-2.5 text-white min-[1200px]:mb-0 min-[1200px]:flex-nowrap"
          role="navigation"
        >
          {getMenu(code).map(
            ({ name, link, external }: NavItemProps, index) => (
              <NavItem
                key={name}
                name={name}
                link={link}
                external={external}
                onClick={() => fireFooterLink(link, index + 1, { label: name })}
              />
            )
          )}
        </div>
        <div
          data-testid="footer-copyright"
          className="flex items-center justify-center text-center text-[14px] font-semibold text-grey-hide min-[1200px]:text-start"
        >
          <CopyRightText />
        </div>
      </div>
    </div>
  );
};

export default MarketplaceFooter;
